export const environment = {
  production: false,
  basePath: 'https://aeltcdevapi.mi2.in/api',
  tenant: 'T00001',
  supportedCountry: ['IN', 'UK',],
  version: 'v 2.23.0',
  mainAppRedirectionURL: "https://ttt.www.wimbledon.com/s/mywimbledon",
  googleMapApiKey: "AIzaSyA3AzoQOrHx4IY7qeiSWgMVHkMrL9fxoKg",
  useSSO: false
};

// export const environment = {
//   production: false,
//   basePath: 'https://aeltcqa-devapi.mi2.in/api',
//   tenant: 'T00011',
//   supportedCountry: ['IN', 'UK'],
//   version: 'v 2.23.0',
//   mainAppRedirectionURL: "https://www-cdt.wimbledon.com/"
// };
